import Axios from "../../configs/axios.config";

/**
 * ⚠️ IMPORTANT: Salary Increment & Salary Structure Integration
 * 
 * When creating/updating a salary increment, the backend should also:
 * 1. Get the staff's current salary structure assignment
 * 2. Create/update the salary structure assignment with the new CTC
 * 3. Set the effective_date to match the increment effective_date
 * 
 * This ensures the Salary Structure system stays in sync with increments.
 * The increment system tracks CTC changes while keeping position/designation the same.
 * 
 * See: /views/main/hr/manageSalaryIncrement/SALARY_INCREMENT_GUIDE.md for details
 */

// Get salary increment list for a staff member
export const getSalaryIncrementList = (data) =>
  Axios.get("/salary/increment", { params: data }).then(
    (response) => response.data
  );

// Get salary increment detail
export const getSalaryIncrementDetail = (id) =>
  Axios.get(`/salary/increment/${id}`).then((response) => response.data.data);

// Create salary increment
// ⚠️ Backend should also update/create salary structure assignment with new CTC
export const createSalaryIncrement = (data) =>
  Axios.post(`/salary/increment`, data).then((response) => response.data.data);

// Update salary increment
export const updateSalaryIncrement = (data, id) =>
  Axios.put(`/salary/increment/${id}`, data).then(
    (response) => response.data.data
  );

// Delete salary increment
export const deleteSalaryIncrement = (id) =>
  Axios.delete(`/salary/increment/${id}`);

// Get increment history for a staff member
export const getStaffIncrementHistory = (staffId, data) =>
  Axios.get(`/salary/increment/staff/${staffId}`, { params: data }).then(
    (response) => response.data
  );

